<template>
<pop-up-layout 
  :title="(nuevoComercial ? $t('general.misc.nuevo') : $t('general.misc.editar') + ' ' + $t('general.misc.usuario'))"
  :description="nuevoComercial ? $t('comerciales.descripcionNuevoUsuario') : $t('comerciales.descripcionEditUsuario', {usuario: comercialEditado.NOMBRE_ACTOR})"
  :aceptar="nuevoComercial ? $t('general.misc.crear') : $t('general.misc.guardar')"
  :disabled="!cambiado"
  :saving="waitingForLoad"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <v-form v-model="valid" ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('general.misc.nombre')"
          :value="nombre"
          v-model="nombre"
          :rules="[rules.required,rules.max(100)]"
        />
      </v-flex>
      <v-flex xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('general.misc.apellidos')"
          :value="apellidos" 
          v-model="apellidos"
          :rules="[rules.required,rules.max(100)]"
        />
      </v-flex>
      <v-flex xs12 sm6 md6 px-2>
        <v-select
          :label="$t('comerciales.tipoDocumento')"
          :items="getTiposDocumentos"
          item-text="DESC_TIPO_DOCUMENTO_ID"
          item-value="COD_TIPO_DOCUMENTO_ID"
          v-model="tipoDocumento"
          :rules="[rules.required]"
        />
      </v-flex>
      <v-flex xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('comerciales.numDocumento')"
          :value="numeroDocumento"
          @input="numeroDocumento = $event != null ? $event.toUpperCase() : $event"
          :rules="[rules.required,rules.max(20), rules.numberUppercase, rules.validarNif(tipoDocumento)]"
        />
      </v-flex>
      <v-flex v-if="!nuevoComercial" xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('general.misc.telefono')"
          :value="telefono" 
          v-model="telefono"
          :rules="[rules.integerNumber, rules.required, rules.max(20)]"
        />
      </v-flex>
      <v-flex v-else xs12 sm6 md6 px-2>
        <v-select
          v-model="rolesSelect"
          :items="roles"
          :label="$t('general.misc.rol')"
          item-text="descripcion"
          item-value="codigo"
          :rules="[rules.required]"
        />
      </v-flex>
      <v-flex v-if="nuevoComercial" xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('general.misc.correoElectronico')"
          :value="email" 
          v-model="email"
          :rules="[rules.required, rules.email, rules.max(100)]"
        />
      </v-flex>
      <v-flex v-if="!nuevoComercial" xs12 sm6 md6 px-2>
        <v-select
          v-model="rolesSelect"
          :items="roles"
          :label="$t('general.misc.roles')"
          item-text="descripcion"
          item-value="codigo"
          class="multipleSelect selectText"
          multiple
          :rules="[rules.required]"
        >
          <v-list-tile
            slot="prepend-item"
            ripple
            @click.stop="toggleSelectRoles"
          >
            <v-list-tile-action>
              <v-icon :color="rolesSelect.length > 0 ? 'primary' : ''">{{ iconoRoles }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title :class="rolesSelect.length > 0 ? 'primary--text' : ''">{{rolesSelect.length === roles.length ? $t('general.misc.deseleccionarTodos') : $t('general.misc.seleccionarTodos')}}</v-list-tile-title>
          </v-list-tile>
        </v-select>
      </v-flex>
      <v-flex xs12 sm6 md6 px-2>
        <v-text-field
          :label="$t('general.misc.usuarioBackoffice')"
          :value="usuBkof"
          disabled
        />
      </v-flex>
    </v-layout>
  </v-form>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    nuevoComercial: {
      type: Boolean,
      default: false
    },
    comercialEditado: {
      type: Object
    }
  },
  data () {
    return {
      waitingForLoad: false,
      valid: true,
      cambiadoData: false,
      comercialBase: {
        nombre: '',
        apellidos: '',
        tipoDocumento: '',
        numeroDocumento: '',
        telefono: '',
        email: '',
        roles: ''
      },
      nombre: '',
      apellidos: '',
      tipoDocumento: '',
      numeroDocumento: '',
      telefono: '',
      email: '',
      rolesSelect: ''
    }
  },
  created () {
    if (!this.nuevoComercial) {
      this.nombre = this.comercialEditado.NOMBRE_ACTOR
      this.apellidos = this.comercialEditado.APELLIDOS_ACTOR
      this.numeroDocumento = this.comercialEditado.NUM_DOCUMENTO_ACTOR
      this.tipoDocumento = this.auxTipoDoc == null ? '' : this.auxTipoDoc.COD_TIPO_DOCUMENTO_ID
      this.telefono = this.comercialEditado.TELEFONO_ACTOR
      this.email = this.comercialEditado.EMAIL_ACTOR
      this.rolesSelect = this.comercialEditado.roles
      this.comercialBase = {
        nombre: this.nombre,
        apellidos: this.apellidos,
        tipoDocumento: this.tipoDocumento,
        numeroDocumento: this.numeroDocumento,
        telefono: this.telefono,
        email: this.email,
        roles: this.rolesSelect
      }
    }
    this.cambiadoData = false
    this.$emit('cambiado', false)
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      getTiposDocumentos: 'maestros/tiposDocumentos/getAll',
      roles: 'maestros/roles/getAll'
    }),
    cambiado () {
      if (this.cambiadoData) {
        return true
      }
      // eslint-disable-next-line
      this.cambiadoData = this.cambiadoData ||
        this.nombre !== this.comercialBase.nombre ||
        this.apellidos !== this.comercialBase.apellidos ||
        this.numeroDocumento !== this.comercialBase.numeroDocumento ||
        this.tipoDocumento !== this.comercialBase.tipoDocumento ||
        this.telefono !== this.comercialBase.telefono ||
        this.email !== this.comercialBase.email ||
        this.rolesSelect.length !== this.comercialBase.roles.length
      if (this.cambiadoData) {
        this.$emit('cambiado', true)
      }
      return this.cambiadoData
    },
    iconoRoles () {
      if (this.allSelectRoles) return 'mdi-close-box'
      if (this.multipleSelectRoles) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allSelectRoles () {
      return this.rolesSelect.length === this.roles.length
    },
    multipleSelectRoles () {
      return this.rolesSelect.length > 0 && !this.allSelectRoles
    },
    auxTipoDoc () {
      return this.getTiposDocumentos.find(x => x.COD_TIPO_DOCUMENTO_ID_BKND === this.comercialEditado.TIPO_DOCUMENTO_ACTOR)
    },
    usuBkof () {
      return this.nuevoComercial ? '' : this.comercialEditado.USU_BKOF
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      crearComercial: 'comerciales/crear',
      modificarDatos: 'comerciales/modificarDatos'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        if (this.nuevoComercial) {
          await this.crearComercial({
            email: this.email,
            nombre: this.nombre,
            apellidos: this.apellidos,
            tipoDocumento: this.tipoDocumento,
            numeroDocumento: this.numeroDocumento,
            rol: this.rolesSelect
          })
        } else {
          await this.modificarDatos({
            email: this.email,
            nombre: this.nombre,
            apellidos: this.apellidos,
            numeroDocumento: this.numeroDocumento,
            tipoDocumento: this.tipoDocumento,
            telefono: this.telefono,
            rol: this.rolesSelect
          })
        }
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('comerciales.guardarUsuario'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    toggleSelectRoles () {
      this.$nextTick(() => {
        if (this.allSelectRoles) {
          this.rolesSelect = []
        } else {
          this.rolesSelect = this.roles.map(x => x.codigo)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/comerciales/EditarComercial.vue